import { type FC } from "react";

import { type Attribute } from "../../../../graphql.js";
import ScriptInputField, { ScriptingLanguage } from "../../forms/ScriptInputField.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const JavascriptScriptingCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }
  const { context } = props;
  const attributes: Attribute[] = context.attributesForDecoration;

  return (
    <TableCell className={"cm-cell cm-display-mode"}>
      <ScriptInputField
        setSyntaxError={undefined}
        scriptingLanguage={ScriptingLanguage.JAVASCRIPT}
        attributes={attributes ?? []}
        initialValue={(props.value as string)?.replace(/\n/g, " ") /*.replaceAll("{", "$")*/}
        disabled={true}
      />
    </TableCell>
  );
};

export { JavascriptScriptingCell };
